module.exports = __webpack_public_path__ + "img/pr-40.8483dc2e.png";